/* istanbul ignore file */
import { MediumFormRow } from 'framework/ui/layout';
import { DefaultInputPropTypes, Dropdown, TextInput, useInputHelper } from 'framework/form';
import { OPPORTUNITY_STAGES, PROBABILITY_MAP } from 'domain/sales/opportunity/opportunityService';

const OpportunityStateInput = (props: DefaultInputPropTypes<any>) => {
  const { getValue } = useInputHelper(props);
  const value = getValue();

  return (
    <MediumFormRow>
      <Dropdown
        placeholder="Choose opportunity state"
        options={Object.entries(OPPORTUNITY_STAGES).map(entry => {
          const [key, label] = entry;

          return {
            value: key,
            label,
          };
        })}
        label="Opportunity state"
        {...props}
      />
      <TextInput source="" value={`${PROBABILITY_MAP[value] || 0}%`} label="Probability" disabled />
    </MediumFormRow>
  );
};

export default OpportunityStateInput;
